module.exports = __webpack_public_path__ + "static/articles-88234a990aa0cfbc309394abcd92a40f.jpg";